import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router'; // ← ajouter RouterModule
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header-public',
  imports: [RouterModule], // ← ajouter RouterModule ici
  templateUrl: './header-public.component.html',
  styleUrls: ['./header-public.component.css'],
})
export class HeaderPublicComponent {
  readonly isLoggedIn = this.authService.isLoggedIn;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  logout(): void {
    this.authService.logout();
  }

  navigateToSection(sectionId: string) {
    if (this.router.url !== '/') {
      this.router.navigate(['/']).then(() => {
        this.scrollTo(sectionId);
      });
    } else {
      this.scrollTo(sectionId);
    }
  }

  private scrollTo(sectionId: string) {
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 70;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 50);
  }

  goHome() {
    this.router.navigate(['/']).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}
